/**
 * Data Transformer Layer
 * Centralizes data normalization between API and UI.
 */

/**
 * Transforms date strings with hyphens to Date objects.
 * Handles format: "YYYY-MM-DD"
 */
export const transformDate = (data) =>
  data.map((d) => ({
    ...d,
    date: d.date ? new Date(d.date.replace(/-/g, "/")) : null,
  }));

/**
 * Transforms HistoryDate strings to Date objects.
 * Handles format: "YYYY-MM-DDTHH:mm:ssZ"
 */
export const transformHistoryDate = (data) =>
  data.map((d) => ({
    ...d,
    HistoryDate: d.HistoryDate ? new Date(d.HistoryDate.replace("Z", "")) : null,
  }));

/**
 * Transforms raw date strings to Date objects.
 * Handles format: "YYYY-MM-DDTHH:mm:ssZ"
 */
export const transformRawDate = (data) =>
  data.map((d) => {
    const newD = { ...d };
    if (newD.date) {
      newD.date = new Date(newD.date.replace("Z", ""));
    }
    return newD;
  });

/**
 * Transforms oxygen data to a normalized shape.
 */
export const transformOxygenData = (data) =>
  data.map((d) => ({
    date: d.date ? new Date(d.date.replace("Z", "")) : null,
    oxygen: d.value,
  }));

/**
 * Base transformer that can be extended.
 */
export const apiTransformer = {
  date: transformDate,
  historyDate: transformHistoryDate,
  rawDate: transformRawDate,
  oxygen: transformOxygenData,
};
